import { FC } from "react";
import { TodoItem } from "../../types";
import {
  Queue,
  QueueSection,
  QueueSectionTrigger,
  QueueSectionLabel,
  QueueSectionContent,
  QueueList,
  QueueItem,
  QueueItemIndicator,
  QueueItemContent,
} from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconChecklist } from "@tabler/icons-react";

interface TodoProgressProps {
  todos: TodoItem[];
}

export const TodoProgress: FC<TodoProgressProps> = ({ todos }) => {
  const completedCount = todos.filter(
    (todo) => todo.status === "completed",
  ).length;
  const totalCount = todos.length;

  return (
    <Queue className="al-w-fit">
      <QueueSection defaultOpen>
        <QueueSectionTrigger>
          <QueueSectionLabel
            count={completedCount}
            label={`of ${totalCount} tasks complete`}
            icon={<IconChecklist className="al-size-4" />}
          />
        </QueueSectionTrigger>
        <QueueSectionContent>
          <QueueList>
            {todos.map((todo) => (
              <QueueItem key={todo.id}>
                <Stack align="center">
                  <QueueItemIndicator status={todo.status} />
                  <QueueItemContent status={todo.status}>
                    {todo.content}
                  </QueueItemContent>
                </Stack>
              </QueueItem>
            ))}
          </QueueList>
        </QueueSectionContent>
      </QueueSection>
    </Queue>
  );
};
